// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Ritoppu_Action = require("../Ritoppu.Action/index.js");
var Ritoppu_Action_CastTargeting = require("../Ritoppu.Action.CastTargeting/index.js");
var Ritoppu_Action_CreatureAct = require("../Ritoppu.Action.CreatureAct/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Point = require("../Ritoppu.Model.Point/index.js");
var Ritoppu_Model_Stats = require("../Ritoppu.Model.Stats/index.js");
var Ritoppu_Mutation_Game = require("../Ritoppu.Mutation.Game/index.js");
var Ritoppu_Mutation_Inventory = require("../Ritoppu.Mutation.Inventory/index.js");
var Ritoppu_Mutation_Player = require("../Ritoppu.Mutation.Player/index.js");
var Ritoppu_Mutation_Stage = require("../Ritoppu.Mutation.Stage/index.js");
var Ritoppu_Mutation_Stats = require("../Ritoppu.Mutation.Stats/index.js");
var removeItem = function (item) {
    return function (game) {
        return {
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: game.stage.player.stats,
                    turn: game.stage.player.turn,
                    inventory: Ritoppu_Mutation_Inventory.removeItemFromInventory(item)(game.stage.player.inventory),
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        };
    };
};
var playerTurn = function (game) {
    return {
        stage: {
            player: {
                pos: game.stage.player.pos,
                stats: game.stage.player.stats,
                turn: game.stage.player.turn + 5 | 0,
                inventory: game.stage.player.inventory,
                level: game.stage.player.level,
                equipment: game.stage.player.equipment
            },
            tiles: game.stage.tiles,
            size: game.stage.size,
            seen: game.stage.seen,
            items: game.stage.items,
            fovMask: game.stage.fovMask,
            creatures: game.stage.creatures
        },
        dungeonLevel: game.dungeonLevel
    };
};
var useHealingPotion = function (game) {
    if (Ritoppu_Model_Stats.isFullHealth(game.stage.player.stats)) {
        return Ritoppu_Action.withAction(game)(new Ritoppu_Action.LogMessage(Ritoppu_Action.FullHealth.value));
    };
    return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(Ritoppu_Action.Healed.value))(Ritoppu_Action_CreatureAct.creatureAct(removeItem(Ritoppu_Model_Item.HealingPotion.value)(playerTurn({
        stage: {
            player: {
                pos: game.stage.player.pos,
                stats: Ritoppu_Mutation_Stats.heal(40)(game.stage.player.stats),
                turn: game.stage.player.turn,
                inventory: game.stage.player.inventory,
                level: game.stage.player.level,
                equipment: game.stage.player.equipment
            },
            tiles: game.stage.tiles,
            size: game.stage.size,
            seen: game.stage.seen,
            items: game.stage.items,
            fovMask: game.stage.fovMask,
            creatures: game.stage.creatures
        },
        dungeonLevel: game.dungeonLevel
    }))));
};
var addItem$prime = function (item) {
    return function (game) {
        return {
            stage: {
                player: {
                    pos: game.stage.player.pos,
                    stats: game.stage.player.stats,
                    turn: game.stage.player.turn,
                    inventory: Ritoppu_Mutation_Inventory.addItemToInventory(item)(game.stage.player.inventory),
                    level: game.stage.player.level,
                    equipment: game.stage.player.equipment
                },
                tiles: game.stage.tiles,
                size: game.stage.size,
                seen: game.stage.seen,
                items: game.stage.items,
                fovMask: game.stage.fovMask,
                creatures: game.stage.creatures
            },
            dungeonLevel: game.dungeonLevel
        };
    };
};
var useMainHandItem = function (item) {
    return function (game) {
        var powerDelta = function (v) {
            if (v instanceof Ritoppu_Model_Equipment.Dagger) {
                return 2;
            };
            if (v instanceof Ritoppu_Model_Equipment.Sword) {
                return 3;
            };
            throw new Error("Failed pattern match at Ritoppu.Action.UseItem (line 69, column 16 - line 71, column 15): " + [ v.constructor.name ]);
        };
        if (game.stage.player.equipment.mainHand instanceof Data_Maybe.Nothing) {
            return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.TakeOn(Data_Show.show(Ritoppu_Model_Equipment.showMainHandItem)(item))))(Ritoppu_Action_CreatureAct.creatureAct(removeItem(new Ritoppu_Model_Item.MainHandItem(item))(playerTurn({
                stage: {
                    player: {
                        pos: game.stage.player.pos,
                        stats: {
                            maxHp: game.stage.player.stats.maxHp,
                            hp: game.stage.player.stats.hp,
                            defense: game.stage.player.stats.defense,
                            power: game.stage.player.stats.power + powerDelta(item) | 0
                        },
                        turn: game.stage.player.turn,
                        inventory: game.stage.player.inventory,
                        level: game.stage.player.level,
                        equipment: {
                            mainHand: new Data_Maybe.Just(item),
                            offHand: game.stage.player.equipment.offHand
                        }
                    },
                    tiles: game.stage.tiles,
                    size: game.stage.size,
                    seen: game.stage.seen,
                    items: game.stage.items,
                    fovMask: game.stage.fovMask,
                    creatures: game.stage.creatures
                },
                dungeonLevel: game.dungeonLevel
            }))));
        };
        if (game.stage.player.equipment.mainHand instanceof Data_Maybe.Just) {
            return Ritoppu_Action.addActions([ new Ritoppu_Action.LogMessage(new Ritoppu_Action.TakeOn(Data_Show.show(Ritoppu_Model_Equipment.showMainHandItem)(item))), new Ritoppu_Action.LogMessage(new Ritoppu_Action.TookOff(Data_Show.show(Ritoppu_Model_Equipment.showMainHandItem)(game.stage.player.equipment.mainHand.value0))) ])(Ritoppu_Action_CreatureAct.creatureAct(addItem$prime(new Ritoppu_Model_Item.MainHandItem(game.stage.player.equipment.mainHand.value0))(removeItem(new Ritoppu_Model_Item.MainHandItem(item))(playerTurn({
                stage: {
                    player: {
                        pos: game.stage.player.pos,
                        stats: {
                            maxHp: game.stage.player.stats.maxHp,
                            hp: game.stage.player.stats.hp,
                            defense: game.stage.player.stats.defense,
                            power: (game.stage.player.stats.power - powerDelta(game.stage.player.equipment.mainHand.value0) | 0) + powerDelta(item) | 0
                        },
                        turn: game.stage.player.turn,
                        inventory: game.stage.player.inventory,
                        level: game.stage.player.level,
                        equipment: {
                            mainHand: new Data_Maybe.Just(item),
                            offHand: game.stage.player.equipment.offHand
                        }
                    },
                    tiles: game.stage.tiles,
                    size: game.stage.size,
                    seen: game.stage.seen,
                    items: game.stage.items,
                    fovMask: game.stage.fovMask,
                    creatures: game.stage.creatures
                },
                dungeonLevel: game.dungeonLevel
            })))));
        };
        throw new Error("Failed pattern match at Ritoppu.Action.UseItem (line 29, column 29 - line 64, column 8): " + [ game.stage.player.equipment.mainHand.constructor.name ]);
    };
};
var useOffHandItem = function (item) {
    return function (game) {
        var defenseDelta = function (v) {
            return 1;
        };
        if (game.stage.player.equipment.offHand instanceof Data_Maybe.Nothing) {
            return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.TakeOn(Data_Show.show(Ritoppu_Model_Equipment.showOffHandItem)(item))))(Ritoppu_Action_CreatureAct.creatureAct(removeItem(new Ritoppu_Model_Item.OffHandItem(item))(playerTurn({
                stage: {
                    player: {
                        pos: game.stage.player.pos,
                        stats: {
                            maxHp: game.stage.player.stats.maxHp,
                            hp: game.stage.player.stats.hp,
                            defense: game.stage.player.stats.defense + defenseDelta(item) | 0,
                            power: game.stage.player.stats.power
                        },
                        turn: game.stage.player.turn,
                        inventory: game.stage.player.inventory,
                        level: game.stage.player.level,
                        equipment: {
                            mainHand: game.stage.player.equipment.mainHand,
                            offHand: new Data_Maybe.Just(item)
                        }
                    },
                    tiles: game.stage.tiles,
                    size: game.stage.size,
                    seen: game.stage.seen,
                    items: game.stage.items,
                    fovMask: game.stage.fovMask,
                    creatures: game.stage.creatures
                },
                dungeonLevel: game.dungeonLevel
            }))));
        };
        if (game.stage.player.equipment.offHand instanceof Data_Maybe.Just) {
            return Ritoppu_Action.addActions([ new Ritoppu_Action.LogMessage(new Ritoppu_Action.TakeOn(Data_Show.show(Ritoppu_Model_Equipment.showOffHandItem)(item))), new Ritoppu_Action.LogMessage(new Ritoppu_Action.TookOff(Data_Show.show(Ritoppu_Model_Equipment.showOffHandItem)(game.stage.player.equipment.offHand.value0))) ])(Ritoppu_Action_CreatureAct.creatureAct(addItem$prime(new Ritoppu_Model_Item.OffHandItem(game.stage.player.equipment.offHand.value0))(removeItem(new Ritoppu_Model_Item.OffHandItem(item))(playerTurn({
                stage: {
                    player: {
                        pos: game.stage.player.pos,
                        stats: {
                            maxHp: game.stage.player.stats.maxHp,
                            hp: game.stage.player.stats.hp,
                            defense: (game.stage.player.stats.defense - defenseDelta(game.stage.player.equipment.offHand.value0) | 0) + defenseDelta(item) | 0,
                            power: game.stage.player.stats.power
                        },
                        turn: game.stage.player.turn,
                        inventory: game.stage.player.inventory,
                        level: game.stage.player.level,
                        equipment: {
                            mainHand: game.stage.player.equipment.mainHand,
                            offHand: new Data_Maybe.Just(item)
                        }
                    },
                    tiles: game.stage.tiles,
                    size: game.stage.size,
                    seen: game.stage.seen,
                    items: game.stage.items,
                    fovMask: game.stage.fovMask,
                    creatures: game.stage.creatures
                },
                dungeonLevel: game.dungeonLevel
            })))));
        };
        throw new Error("Failed pattern match at Ritoppu.Action.UseItem (line 74, column 28 - line 109, column 8): " + [ game.stage.player.equipment.offHand.constructor.name ]);
    };
};
var addExperience = function (xp) {
    return function (stage) {
        return {
            player: Ritoppu_Mutation_Player.gainXp(xp)(stage.player),
            tiles: stage.tiles,
            size: stage.size,
            seen: stage.seen,
            items: stage.items,
            fovMask: stage.fovMask,
            creatures: stage.creatures
        };
    };
};
var useLightningScroll = function (game) {
    var target = Data_Foldable.minimumBy(Data_Foldable.foldableArray)(function (v) {
        return function (v1) {
            return Data_Ord.compare(Data_Ord.ordInt)(Ritoppu_Model_Point.doubleDistanceBetween(v.value0)(game.stage.player.pos))(Ritoppu_Model_Point.doubleDistanceBetween(v1.value0)(game.stage.player.pos));
        };
    })(Data_Array.filter(function (v) {
        return Ritoppu_Model_Point.doubleDistanceBetween(v.value0)(game.stage.player.pos) <= 25;
    })(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(game.stage.creatures)));
    var actedGame = removeItem(Ritoppu_Model_Item.LightningScroll.value)(playerTurn(game));
    if (target instanceof Data_Maybe.Just && 40 >= target.value0.value1.stats.hp) {
        return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.AttackKillM(target.value0.value1)))(Ritoppu_Action_CreatureAct.creatureAct({
            stage: addExperience(target.value0.value1.xp)(Ritoppu_Mutation_Stage.addItem(target.value0.value0)(Ritoppu_Model_Item.newCorpse(target.value0.value1))(Ritoppu_Mutation_Stage.removeCreature(target.value0.value0)(actedGame.stage))),
            dungeonLevel: actedGame.dungeonLevel
        }));
    };
    if (target instanceof Data_Maybe.Just) {
        return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(new Ritoppu_Action.AttackM(target.value0.value1, 40)))(Ritoppu_Action_CreatureAct.creatureAct({
            stage: Ritoppu_Mutation_Stage.updateCreature(target.value0.value0)(function (c) {
                return {
                    type: c.type,
                    stats: Ritoppu_Mutation_Stats.takeDamage(40)(c.stats),
                    turn: c.turn,
                    aiStrategy: c.aiStrategy,
                    xp: c.xp
                };
            })(game.stage),
            dungeonLevel: actedGame.dungeonLevel
        }));
    };
    if (target instanceof Data_Maybe.Nothing && 40 >= game.stage.player.stats.hp) {
        return Ritoppu_Action.die(Ritoppu_Action.withAction(Ritoppu_Mutation_Game.hitPlayer(40)(actedGame))(new Ritoppu_Action.LogMessage(Ritoppu_Action.LightningScrollHitYourself.value)));
    };
    if (target instanceof Data_Maybe.Nothing) {
        return Ritoppu_Action.addAction(new Ritoppu_Action.LogMessage(Ritoppu_Action.LightningScrollHitYourself.value))(Ritoppu_Action_CreatureAct.creatureAct(Ritoppu_Mutation_Game.hitPlayer(40)(actedGame)));
    };
    throw new Error("Failed pattern match at Ritoppu.Action.UseItem (line 145, column 27 - line 160, column 35): " + [ target.constructor.name ]);
};
var useItem = function (v) {
    if (v instanceof Ritoppu_Model_Item.HealingPotion) {
        return useHealingPotion;
    };
    if (v instanceof Ritoppu_Model_Item.LightningScroll) {
        return useLightningScroll;
    };
    if (v instanceof Ritoppu_Model_Item.FireballScroll) {
        var $45 = Ritoppu_Action.target(Ritoppu_Action_CastTargeting.castFireball)("Left-click a target tile for the fireball");
        return function ($46) {
            return $45(Ritoppu_Action.inactive($46));
        };
    };
    if (v instanceof Ritoppu_Model_Item.ConfusionScroll) {
        var $47 = Ritoppu_Action.target(Ritoppu_Action_CastTargeting.castConfusion)("Left-click an enemy to confuse it");
        return function ($48) {
            return $47(Ritoppu_Action.inactive($48));
        };
    };
    if (v instanceof Ritoppu_Model_Item.Corpse) {
        return Data_Function.flip(Ritoppu_Action.withAction)(new Ritoppu_Action.LogMessage(Ritoppu_Action.DoNotKnowHowToUse.value));
    };
    if (v instanceof Ritoppu_Model_Item.MainHandItem) {
        return useMainHandItem(v.value0);
    };
    if (v instanceof Ritoppu_Model_Item.OffHandItem) {
        return useOffHandItem(v.value0);
    };
    throw new Error("Failed pattern match at Ritoppu.Action.UseItem (line 19, column 11 - line 26, column 56): " + [ v.constructor.name ]);
};
module.exports = {
    useItem: useItem
};
